import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dataTestId", "trackingName", "onClose", "scopes"];
import { trackUserInteraction } from '../../tracking/trackingUtils';
import AsyncQuickInviteModalContainer from '../../containers/AsyncQuickInviteModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncQuickInviteModal = _ref => {
  let {
      dataTestId,
      trackingName,
      onClose,
      scopes = []
    } = _ref,
    passthroughModalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClose = () => {
    trackUserInteraction('click close invite modal', trackingName);
    onClose();
  };
  return /*#__PURE__*/_jsx(AsyncQuickInviteModalContainer, Object.assign({
    dataTestId: dataTestId,
    trackingName: trackingName,
    scopes: scopes,
    onClose: handleClose
  }, passthroughModalProps));
};
AsyncQuickInviteModal.preload = AsyncQuickInviteModalContainer.preload;
export default AsyncQuickInviteModal;